import * as yup from 'yup'

export const validateUpdateProductPremiumCharacteristics = yup.object().shape({
    html_description: yup
    .string()
    .min(3, 'LA DESCRIPCIÓN debe tener más de 2 caracteres'),
})